<template>
  <div
    :class="[
      'luckyBoxContainer',
      lotterySetting.boxCount === 1 ? 'center' : 'aside'
    ]"
  >
    <div
      v-for="(item, index) in lotterySetting.boxCount"
      :key="index"
      :class="[
        'boxItem',
        lotterySetting.boxCount === 1 ? 'bigBox' : 'smallBox'
      ]"
      :style="openBoxId === index ? openBoxStyle : initialBoxStyle"
      @click="handleDraw(index)"
    >
      <div
        :class="[
          lotterySetting.boxCount === 1
            ? 'largeShiningItem'
            : 'smallShiningItem',
          { showShine: openBoxId === index && showShine }
        ]"
      ></div>
    </div>
  </div>
</template>

<script>
const SHOW_BOX_SHINE_DURING_TIME = 300;
function delay(msTime) {
  return new Promise(resolve => {
    setTimeout(resolve, msTime);
  });
}

export default {
  data() {
    return {
      openBoxId: -1,
      lotteryPending: false,
      showShine: false
    };
  },
  props: {
    lotterySetting: Object,
    lotteryResult: Array,
    lotteryTicketCount: Number
  },
  mounted() {
    this.prefetchImg(this.lotterySetting.boxOpeningImage);
    this.$emit('reportEvent', {
      event: 'lottery_topic_expo',
      module_name: '1006'
    });
  },
  watch: {
    lotteryResult: function(newVal, oldVal) {
      if (!oldVal && newVal) {
        this.$emit('lotteryFinish');
        if (newVal.length) {
          this.reportDraw(1);
        } else {
          this.reportDraw(0);
        }
      }
      if (oldVal && !newVal) {
        this.reset();
      }
    }
  },
  computed: {
    openBoxStyle() {
      return {
        backgroundImage: `url("${this.lotterySetting.boxOpeningImage}")`
      };
    },
    initialBoxStyle() {
      return {
        backgroundImage: `url("${this.lotterySetting.boxImage}")`
      };
    }
  },
  methods: {
    checkTicket() {
      const hasTicket = this.lotteryTicketCount > 0;
      if (!hasTicket) {
        this.$emit('noTicket');
      }
      return hasTicket;
    },
    async handleDraw(idx) {
      if (this.lotteryPending) {
        return;
      }
      if (!this.checkTicket()) {
        this.reportDraw(0);
        return;
      }
      this.lotteryPending = true;
      this.openBox(idx);
      await delay(SHOW_BOX_SHINE_DURING_TIME);
      this.$emit('fire');
    },
    openBox(idx) {
      this.openBoxId = idx;
      this.showShine = true;
      this.lotteryPending = false;
    },
    reset() {
      this.closeAllBox();
      this.lotteryPending = false;
    },
    closeAllBox() {
      this.openBoxId = -1;
      this.showShine = false;
    },
    reportDraw(is_success = 1) {
      this.$emit('reportEvent', {
        event: 'lottery_button_click',
        module_name: '1006',
        button_name: this.$t
          ? this.$t('track.lucky_box_btn', { n: this.lotterySetting.boxCount })
          : '开盒子_开',
        is_success
      });
    },
    prefetchImg(src) {
      const img = new Image();
      img.src = src;
    }
  }
};
</script>
<style lang="less" scoped>
.luckyBoxContainer {
  position: relative;
  margin-bottom: 129px;
  display: flex;

  &.center {
    justify-content: center;
  }

  &.aside {
    justify-content: space-between;
  }

  .boxItem {
    position: relative;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: flex-start;

    &.bigBox {
      width: 367px;
      height: 400px;
    }

    &.smallBox {
      width: 218px;
      height: 238px;
    }

    .largeShiningItem {
      position: absolute;
      top: 140px;
      left: 50%;
      transform: translateX(-50%);
      width: 1px;
      height: 1px;
      border-radius: 50%;
      z-index: 1;

      &.showShine {
        animation: large-shining 0.5s;
      }
    }
    .smallShiningItem {
      position: absolute;
      top: 80px;
      left: 50%;
      transform: translateX(-50%);
      width: 1px;
      height: 1px;
      border-radius: 50%;
      z-index: 1;

      &.showShine {
        animation: small-shining 0.5s;
      }
    }
  }
}
@keyframes small-shining {
  0% {
    box-shadow: 10px 10px 50px 50px #fff;
  }
  100% {
    box-shadow: 10px 10px 120px 150px #fff;
  }
}
@keyframes large-shining {
  0% {
    box-shadow: 10px 10px 50px 50px #fff;
  }
  100% {
    box-shadow: 10px 10px 200px 250px #fff;
  }
}
</style>
